var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"imageElement",staticClass:"wrap fixed z-99 right-20px bottom-20px cursor-pointer",class:_vm.className},[(_vm.isShow)?_c('el-image',{staticClass:"qrcode",attrs:{"fit":"contain","src":require("@/assets/img/global/home/qr-code.png")},on:{"click":_vm.onShow}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }